import { Component, OnInit, HostListener } from '@angular/core';
import { PaymentService } from './payment.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent {
  imagePath = '../../assets/stocks.jpg';
  constructor(private paymentService: PaymentService) { }


  handlePayment() {
    this.paymentService.signIn();
  }

  @HostListener('window:popstate')
  onPopstate() {
    this.paymentService.handler.close();
  }
}
